import { useCallback, useEffect, useRef, useState } from 'react';

const SCROLL_AMOUNT = 200;

export const useScrollNavigation = () => {
	const trackRef = useRef<HTMLDivElement>(null);
	const [canScrollLeft, setCanScrollLeft] = useState(false);
	const [canScrollRight, setCanScrollRight] = useState(false);

	const updateScrollState = useCallback(() => {
		const el = trackRef.current;
		if (!el) return;
		setCanScrollLeft(el.scrollLeft > 0);
		setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
	}, []);

	useEffect(() => {
		updateScrollState();
	}, [updateScrollState]);

	const scrollLeft = useCallback(() => {
		trackRef.current?.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' });
	}, []);

	const scrollRight = useCallback(() => {
		trackRef.current?.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' });
	}, []);

	const scrollToElement = useCallback((selector: string) => {
		const track = trackRef.current;
		const el = track?.querySelector<HTMLElement>(selector);
		if (track && el) {
			const targetScrollLeft =
				el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;

			track.scrollTo({
				left: Math.max(0, targetScrollLeft),
				behavior: 'smooth',
			});
		}
	}, []);

	return {
		trackRef,
		canScrollLeft,
		canScrollRight,
		scrollLeft,
		scrollRight,
		scrollToElement,
		onScroll: updateScrollState,
	};
};
